import jcicp from '@/proto/jcicp.js'
import { jcicpEncode, jcicpDecode } from '@/libs/jcicputil.js'
import { reqReverseGeocoder } from '@/libs/baidumaputil.js'
import { reqGDReverseGeocoderDetail } from '@/libs/amaputil.js'
import { GPS } from '@/libs/positonUtils'
import { isAccOn, explainDirection, explainState, explainAlarmSign } from '@/libs/jt808util'

/**
 * 车辆动态数据管理器
 */
class VehicleDymaicManager {
  // vehicleInfo
  //           |--dymaic
  //           |   |---realtimeLocationFrame(实时定位数据帧)
  //           |
  //           |--gis(地图相关元素)
  //           |   |---realtimeMarker(实时显示车辆标注)
  //           |   |---nameLabel(车辆名称标注)
  //           |   |---infoWindow(车辆信息框)
  //           |   |---tracks(车辆轨迹)
  //           |
  //           |--info
  //           |   |---state(车辆状态描述字符串)
  //           |   |---alarm(车辆报警描述字符串)
  //           |   |---speed(车辆速度描述字符串)
  //           |   |---direction(车辆方向描述字符串)
  //           |   |---mileage(车辆累计里程描述字符串)
  //           |   |---address(区域解释)
  //           |   |---addressEx(地址解释)
  //           |   |---gpsDatetime(定位时间描述字符串)
  //           |   |---recvDatetime(接收数据时间描述字符串)
  //           |   |---terminalState(终端状态[0:离线 1:停止 2:行驶])
  //           |   |---terminalStateSpan(终端状态持续时长)
  //           |
  //           |--customChecked(是否选中订阅)
  //           |--keyWordMatch(是否选中查询)
  //           |--consecutiveNoSpeed(连续ACC开但速度为零的次数)

  // 数据结构容器 -----------------------------
  // subscribedVehicleInfos:[],             // 已订阅车辆信息列表
  // vehicleInfoHashMap:{},                 // 车辆信息哈斯表({key:terminalNum, value:VehicleInfo})

  /**
   * 构造函数
   * @returns {VehicleDymaicManager}
   */
  constructor () {
    this.running = true
    this.wsuri = 'wss://rt1.jianchengjt.com:31020/websocket'
    this.realtimeAnalyzePosition = true

    this.subscribedVehicleInfos = []
    this.vehicleInfoHashMap = {}

    this.onRecvDymaicDataCallback = null
    this.onRemoveDymaicDataCallback = null

    this.runCount = 0
    this.stopCount = 0
    this.alarmCount = 0

    // 初始化Websocket
    this.initWebsocket()
    return this
  }

  /**
   * 析构函数
   */
  destroy () {
    this.running = false

    this.websock.close()
    this.websock = null

    this.subscribedVehicleInfos = []
    this.vehicleInfoHashMap = {}

    this.onRecvDymaicDataCallback = null
    this.onCancelSubscribeDymaicDataCallback = null
  }

  /**
   * 数据统计
   */
  calculate () {
    let runCount = 0
    let stopCount = 0
    let alarmCount = 0
    let hashMap = this.vehicleInfoHashMap
    for (var prop in hashMap) {
      let v = hashMap[prop]
      let realtimeLocationFrame = v.dymaic.realtimeLocationFrame
      if (realtimeLocationFrame) {
        if (realtimeLocationFrame.alarm > 0) {
          // 报警
          alarmCount = alarmCount + 1
        } else {
          if (isAccOn(realtimeLocationFrame.state)) {
            runCount = runCount + 1
          } else {
            stopCount = stopCount + 1
          }
        }

        if (realtimeLocationFrame.expand) {
          let expand = JSON.parse(realtimeLocationFrame.expand)
          if (expand.changeTerminalStateDatetime) {
            let leave1 = (new Date().getTime()) - expand.changeTerminalStateDatetime
            let hours = Math.floor(leave1 / (3600 * 1000))
            // 计算相差分钟数
            let leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
            let minutes = Math.floor(leave2 / (60 * 1000))
            // 计算相差秒数
            let leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
            let seconds = Math.round(leave3 / 1000)
            let result = ''
            if (hours > 0) {
              result += hours + '小时'
            }
            if (minutes > 0) {
              result += minutes + '分'
            }
            // if(seconds > 0){
            //   result += seconds + '秒'
            // }
            v.info.terminalStateSpan = result
          }
        }
      }
    }
    this.runCount = runCount
    this.stopCount = stopCount
    this.alarmCount = alarmCount
  }

  /**
   * 加载车辆信息
   * @param vehicleInfo
   */
  putVehicleInfo (vehicleInfos) {
    vehicleInfos.forEach(vehicleInfo => {
      if (vehicleInfo.positioningDeviceInfos && vehicleInfo.positioningDeviceInfos.length > 0) {
        let existVehicleInfo = this.vehicleInfoHashMap[vehicleInfo.positioningDeviceInfos[0].terminalNum]
        if (existVehicleInfo) {
          if (existVehicleInfo.id === vehicleInfo.id) {
            // 重复插入，不作处理
            return
          }
          if (existVehicleInfo.gis.realtimeMarker) {
            existVehicleInfo.gis.realtimeMarker.map = null
            existVehicleInfo.gis.realtimeMarker = null
          }
          if (existVehicleInfo.gis.tracks) {
            existVehicleInfo.gis.tracks.map = null
            existVehicleInfo.gis.tracks = null
          }
          if (existVehicleInfo.gis.nameLabel) {
            existVehicleInfo.gis.nameLabel.map = null
            existVehicleInfo.gis.nameLabel = null
          }
          if (existVehicleInfo.gis.infoWindow) {
            existVehicleInfo.gis.infoWindow.map = null
            existVehicleInfo.gis.infoWindow = null
          }
        }
        vehicleInfo.customChecked = false
        vehicleInfo.keyWordMatch = null
        vehicleInfo.consecutiveNoSpeed = 0
        vehicleInfo.dymaic = {
          realtimeLocationFrame: null
        }
        vehicleInfo.gis = {
          realtimeMarker: null,
          nameLabel: null,
          tracks: null,
          infoWindow: null
        }
        vehicleInfo.info = {
          state: '未知',
          alarm: '未知',
          speed: '未知',
          direction: '未知',
          mileage: '未知',
          address: '未知',
          addressEx: '未知',
          gpsDatetime: '未知',
          recvDatetime: '未知',
          terminalState: '未知'
        }
        this.vehicleInfoHashMap[vehicleInfo.positioningDeviceInfos[0].terminalNum] = vehicleInfo
      }
    })
  }

  /**
   * 根据主机号获取车辆信息
   * @param terminalNum
   * @returns {*}
   */
  findVehicleInfoByTerminalNum (terminalNum) {
    return this.vehicleInfoHashMap[terminalNum]
  }

  /**
   * 使用终端号订阅动态数据
   * @param selectedVehicleInfos
   */
  subscribeDymaicDataByTerminalNum (terminalNums) {
    let addList = [] // 需要新增订阅列表
    let removeList = [] // 需要取消订阅列表
    let selectedVehicleInfos = []
    let isAdd = true
    let isRemove = true

    if (!terminalNums) {
      return
    }
    terminalNums.forEach(terminalNum => {
      let v = this.findVehicleInfoByTerminalNum(terminalNum)
      if (v) {
        selectedVehicleInfos.push(v)
      }
    })

    let selectedVehicleInfosLength = selectedVehicleInfos.length
    let subscribedVehicleInfosLength = this.subscribedVehicleInfos.length

    // 查找需要新增订阅车辆
    console.log('查找需要新增订阅车辆')
    for (var i = 0; i < selectedVehicleInfosLength; i++) {
      isAdd = true
      for (var j = 0; j < subscribedVehicleInfosLength; j++) {
        if (selectedVehicleInfos[i].id === this.subscribedVehicleInfos[j].id) {
          isAdd = false
          break
        }
        // if(selectedVehicleInfos[i].registrationNum){
        //   if (this.subscribedVehicleInfos[j].registrationNum === selectedVehicleInfos[i].registrationNum &&
        //     this.subscribedVehicleInfos[j].registrationColor === selectedVehicleInfos[i].registrationColor) {
        //     isAdd = false
        //     break
        //   }
        // }else{
        //   if (this.subscribedVehicleInfos[j].vin === selectedVehicleInfos[i].vin) {
        //     isAdd = false
        //     break
        //   }
        // }
      }
      if (isAdd) {
        selectedVehicleInfos[i].customChecked = true
        addList.push(selectedVehicleInfos[i])
      }
    }

    // 查找需要取消订阅车辆
    console.log('查找需要取消订阅车辆')
    for (var j = 0; j < subscribedVehicleInfosLength; j++) {
      isRemove = true
      for (var i = 0; i < selectedVehicleInfosLength; i++) {
        if (selectedVehicleInfos[i].id === this.subscribedVehicleInfos[j].id) {
          isRemove = false
          break
        }

        // if(selectedVehicleInfos[i].registrationNum){
        //   if (this.subscribedVehicleInfos[j].registrationNum == selectedVehicleInfos[i].registrationNum &&
        //     this.subscribedVehicleInfos[j].registrationColor == selectedVehicleInfos[i].registrationColor) {
        //     isRemove = false
        //     break
        //   }
        // }else{
        //   if (this.subscribedVehicleInfos[j].vin == selectedVehicleInfos[i].vin) {
        //     isRemove = false
        //     break
        //   }
        // }
      }
      if (isRemove) {
        this.subscribedVehicleInfos[j].customChecked = false
        this.subscribedVehicleInfos[j].dymaic.realtimeLocationFrame = null
        removeList.push(this.subscribedVehicleInfos[j])
      }
    }

    // this.subscribedVehicleInfos = selectedVehicleInfos
    this.subscribedVehicleInfos.push(addList)

    // 订阅新增
    console.log('订阅新增')
    console.log(addList)
    this.subscribeVehicles(addList)
    // 取消订阅移除
    console.log('取消订阅移除')
    this.cancelSubscribeVehicles(removeList)

    // 回调
    if (this.onCancelSubscribeDymaicDataCallback && removeList && removeList.length > 0) {
      // console.log('onRemoveDymaicDataCallback')
      this.onCancelSubscribeDymaicDataCallback(removeList)
    }
  }

  /**
   * 订阅动态数据
   * @param selectedVehicleInfos
   */
  subscribeDymaicData (selectedVehicleInfos, isOnlyAdd) {
    if (!isOnlyAdd) {
      isOnlyAdd = false
    }

    let addList = [] // 需要新增订阅列表
    let removeList = [] // 需要取消订阅列表
    let isAdd = true
    let isRemove = true
    let selectedVehicleInfosLength = selectedVehicleInfos.length
    let subscribedVehicleInfosLength = this.subscribedVehicleInfos.length

    // 查找需要新增订阅车辆
    console.log('查找需要新增订阅车辆')
    for (var i = 0; i < selectedVehicleInfosLength; i++) {
      isAdd = true
      for (var j = 0; j < subscribedVehicleInfosLength; j++) {
        if (selectedVehicleInfos[i].id === this.subscribedVehicleInfos[j].id) {
          isAdd = false
          break
        }
        // if(selectedVehicleInfos[i].registrationNum){
        //   if (this.subscribedVehicleInfos[j].registrationNum === selectedVehicleInfos[i].registrationNum &&
        //     this.subscribedVehicleInfos[j].registrationColor === selectedVehicleInfos[i].registrationColor) {
        //     isAdd = false
        //     break
        //   }
        // }else{
        //   if (this.subscribedVehicleInfos[j].vin === selectedVehicleInfos[i].vin) {
        //     isAdd = false
        //     break
        //   }
        // }
      }
      if (isAdd) {
        selectedVehicleInfos[i].customChecked = true
        addList.push(selectedVehicleInfos[i])
      }
    }

    // 查找需要取消订阅车辆
    if (!isOnlyAdd) {
      console.log('查找需要取消订阅车辆')
      for (var j = 0; j < subscribedVehicleInfosLength; j++) {
        isRemove = true
        for (var i = 0; i < selectedVehicleInfosLength; i++) {
          if (selectedVehicleInfos[i].id === this.subscribedVehicleInfos[j].id) {
            isRemove = false
            break
          }

          // if(selectedVehicleInfos[i].registrationNum){
          //   if (this.subscribedVehicleInfos[j].registrationNum == selectedVehicleInfos[i].registrationNum &&
          //     this.subscribedVehicleInfos[j].registrationColor == selectedVehicleInfos[i].registrationColor) {
          //     isRemove = false
          //     break
          //   }
          // }else{
          //   if (this.subscribedVehicleInfos[j].vin == selectedVehicleInfos[i].vin) {
          //     isRemove = false
          //     break
          //   }
          // }
        }
        if (isRemove) {
          this.subscribedVehicleInfos[j].customChecked = false
          this.subscribedVehicleInfos[j].dymaic.realtimeLocationFrame = null
          removeList.push(this.subscribedVehicleInfos[j])
        }
      }
    }

    // this.subscribedVehicleInfos = selectedVehicleInfos
    if (addList) {
      // 订阅新增
      addList.forEach(av => {
        this.subscribedVehicleInfos.push(av)
      })
      console.log('总订阅数' + this.subscribedVehicleInfos.length)
      console.log('订阅新增' + addList.length)
      this.subscribeVehicles(addList)
    }

    if (!isOnlyAdd) {
      // 取消订阅移除
      console.log('取消订阅移除')
      this.cancelSubscribeVehicles(removeList)
      // 回调
      if (this.onCancelSubscribeDymaicDataCallback && removeList && removeList.length > 0) {
        // console.log('onRemoveDymaicDataCallback')
        this.onCancelSubscribeDymaicDataCallback(removeList)
      }
    }
  }

  /**
   * 订阅
   * @param vehicleList
   */
  subscribeVehicles (vehicleList) {
    let subscribeDeviceLocationFrameBuilder = jcicp.lookup('SubscribeDeviceLocationFrame')
    let terminalNums = []
    vehicleList.forEach(item => {
      if (item.positioningDeviceInfos && item.positioningDeviceInfos[0]) {
        terminalNums.push(item.positioningDeviceInfos[0].terminalNum)
        // console.log('subscribe ' + item.positioningDeviceInfos[0].terminalNum)
      }
    })
    let subscribeDeviceLocationFrame = subscribeDeviceLocationFrameBuilder.create({
      selectAll: false,
      terminalNums: terminalNums
    })
    let buffer = subscribeDeviceLocationFrameBuilder.encode(subscribeDeviceLocationFrame).finish()
    let data = jcicpEncode('SubscribeDeviceLocationFrame', buffer)
    this.websock.send(data)
  }

  /**
   * 取消订阅
   * @param vehicleList
   */
  cancelSubscribeVehicles (vehicleList) {
    let tempVehicleList = vehicleList
    vehicleList = []
    tempVehicleList.forEach(item => {
      vehicleList.push(item)
    })

    let unsubscribeDeviceLocationFrameBuilder = jcicp.lookup('UnsubscribeDeviceLocationFrame')
    let terminalNums = []
    let removeList = []
    for (let i = 0; i < vehicleList.length; i++) {
      for (let j = 0; j < this.subscribedVehicleInfos.length; j++) {
        if (vehicleList[i].id === this.subscribedVehicleInfos[j].id) {
          terminalNums.push(this.subscribedVehicleInfos[j].positioningDeviceInfos[0].terminalNum)
          removeList.push(this.subscribedVehicleInfos[j])
          this.subscribedVehicleInfos[j].customChecked = false
          this.subscribedVehicleInfos[j].dymaic.realtimeLocationFrame = null
          this.subscribedVehicleInfos.splice(j, 1)
          // console.log(this.subscribedVehicleInfos.length)
          break
        }
      }
    }
    console.log('删除完成')
    console.log(this.subscribedVehicleInfos.length)
    let unsubscribeDeviceLocationFrame = unsubscribeDeviceLocationFrameBuilder.create({
      selectAll: false,
      terminalNums: terminalNums
    })
    let buffer = unsubscribeDeviceLocationFrameBuilder.encode(unsubscribeDeviceLocationFrame).finish()
    let data = jcicpEncode('UnsubscribeDeviceLocationFrame', buffer)
    this.websock.send(data)

    // 回调
    if (this.onCancelSubscribeDymaicDataCallback && removeList && removeList.length > 0) {
      this.onCancelSubscribeDymaicDataCallback(removeList)
    }
  }

  /**
   * 接收实时定位数据回调函数
   * @param realtimeLocationFrame
   * @param ws
   */
  onRecvRealtimeLocationFrame (realtimeLocationFrame, ws) {
    // 转换状态字
    realtimeLocationFrame.state = Number('0x' + realtimeLocationFrame.state)
    // 转换报警字
    realtimeLocationFrame.alarm = Number('0x' + realtimeLocationFrame.alarm)

    let vehicleInfo = this.vehicleInfoHashMap[realtimeLocationFrame.terminalNum]

    if (vehicleInfo && vehicleInfo.customChecked) {
      vehicleInfo.dymaic.realtimeLocationFrame = realtimeLocationFrame
      // 更新信息状态
      if (vehicleInfo.info) {
        let info = vehicleInfo.info
        info.state = explainState(realtimeLocationFrame.state)
        info.alarm = explainAlarmSign(realtimeLocationFrame.alarm)
        info.speed = (realtimeLocationFrame.speed / 10) + 'km/h'
        info.direction = explainDirection(realtimeLocationFrame.direction)
        info.mileage = (realtimeLocationFrame.mileage / 10) + 'km'
        if (this.realtimeAnalyzePosition) {
        //   reqReverseGeocoder(realtimeLocationFrame.latitude, realtimeLocationFrame.longitude, (address) => {
        //     info.address = address
        //     info.addressEx = null
        //   })
          let GCJ02 = GPS.gcj_encrypt(realtimeLocationFrame.latitude, realtimeLocationFrame.longitude)
          reqGDReverseGeocoderDetail(GCJ02.lat, GCJ02.lon, (address) => {
            info.address = address.formatted_address
            info.addressEx = null
          })
        } else {
          info.address = '未开启地址解释'
          info.addressEx = '未开启地址解释'
        }
        info.gpsDatetime = new Date(realtimeLocationFrame.gpsDatetime.seconds * 1000).Format('yyyy年MM月dd日 hh时mm分ss秒')
        info.recvDatetime = new Date(realtimeLocationFrame.recvDatetime.seconds * 1000).Format('yyyy年MM月dd日 hh时mm分ss秒')

        if ((realtimeLocationFrame.state & 0x01) == 0x01) {
          if (realtimeLocationFrame.speed == 0) {
            vehicleInfo.consecutiveNoSpeed = vehicleInfo.consecutiveNoSpeed + 1
          } else {
            vehicleInfo.consecutiveNoSpeed = 0
          }
        } else {
          vehicleInfo.consecutiveNoSpeed = 0
        }

        if (realtimeLocationFrame.expand) {
          let expand = JSON.parse(realtimeLocationFrame.expand)
          if (expand.terminalState) {
            if (expand.terminalState === 0) {
              info.terminalState = '离线'
            } else if (expand.terminalState === 1) {
              info.terminalState = '停止'
            } else if (expand.terminalState === 2) {
              info.terminalState = '行驶'
            }
          }
          if (expand.ext808State) {

          }
          if (vehicleInfo.consecutiveNoSpeed >= 3) {
            info.terminalState = '停车未熄火'
          }
          if (expand.changeTerminalStateDatetime) {
            let leave1 = (new Date().getTime()) - expand.changeTerminalStateDatetime
            let hours = Math.floor(leave1 / (3600 * 1000))
            // 计算相差分钟数
            let leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
            let minutes = Math.floor(leave2 / (60 * 1000))
            // 计算相差秒数
            let leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
            // let seconds = Math.round(leave3 / 1000)
            let result = ''
            if (hours > 0) {
              result += hours + '小时'
            }
            if (minutes > 0) {
              result += minutes + '分'
            }
            // if(seconds > 0){
            //   result += seconds + '秒'
            // }
            info.terminalStateSpan = result
          }
        }
      }
      if (this.onRecvDymaicDataCallback) {
        this.onRecvDymaicDataCallback(realtimeLocationFrame)
      }
    } else {
      if (vehicleInfo) {
        console.log('vehicleInfo.customChecked')
        console.log(vehicleInfo.customChecked)
      } else {
        console.log('找不到vehicleInfo')
      }
    }
  }

  /**
   * websocket初始化函数
   * @param wsurl
   */
  initWebsocket () { // 初始化weosocket
    // ws地址
    this.websock = new WebSocket(this.wsuri)
    this.websock.onopen = (e) => {
      console.log('websocket open!')
    }
    this.websock.onclose = (e) => {
      console.log('websocket closed (' + e.code + ')')
      this.websocketReconnect()
    }
    this.websock.onerror = (e) => {
      this.websocketReconnect()
    }
    this.websock.binaryType = 'arraybuffer'
    // 接收数据
    this.websock.addEventListener('message', (event) => {
      let result = jcicpDecode(event.data)
      if (result.frameTypeName === 'RealtimeLocationFrame') {
        this.onRecvRealtimeLocationFrame(result.frame, this.websock)
      }
    }, false)
  }

  /**
   * websocket链接打开回调函数
   * @param event
   */
  // websocketOnOpen(e) {
  //   console.log('websocket open!');
  // }

  /**
   * websocket发送函数
   * @param data
   */
  websocketSend (data) { // 数据发送
    this.websock.send(data)
  }

  /**
   * Websocket链接关闭回调函数
   * @param e
   */
  websocketOnClose (e) { // 关闭
    console.log('websocket closed (' + e.code + ')')
    this.websocketReconnect()
  }

  /**
   * Websocket出错回调函数
   */
  websocketOnError () {
    this.websocketReconnect()
  }

  /**
   * Websocket重连
   */
  websocketReconnect () {
    if (this.running) {
      setTimeout(() => {
        // 没连接上会一直重连，设置延迟避免请求过多
        this.websock = new WebSocket(this.wsuri)
        this.websock.onopen = (e) => {
          console.log('websocketReconnect websocket open!')
          if (this.subscribedVehicleInfos) {
            this.subscribeVehicles(this.subscribedVehicleInfos)
          }
        }
        this.websock.onclose = (e) => {
          console.log('websocket closed (' + e.code + ')')
          this.websocketReconnect()
        }
        this.websock.onerror = (e) => {
          this.websocketReconnect()
        }
        this.websock.binaryType = 'arraybuffer'
        // 接收数据
        this.websock.addEventListener('message', (event) => {
          let result = jcicpDecode(event.data)
          if (result.frameTypeName === 'RealtimeLocationFrame') {
            this.onRecvRealtimeLocationFrame(result.frame, this.websock)
          }
        }, false)
      }, 2000)
    }
  }
}

export { VehicleDymaicManager }
